// import SensorDitoImg from "../images/ProductImg/SensorDito.jpg";
// import SensorFogImg from "../images/ProductImg/SensorFog.jpg";
// import SensorFFImg from "../images/ProductImg/SensorFF.jpg";

// import TouchGGPCapImg from '../images/ProductImg/TouchGGPCap.jpg';
// import TouchPGPCapImg from '../images/ProductImg/TouchPGPCap.jpg';
// import TouchGFPCapImg from '../images/ProductImg/TouchGFPCap.jpg';

// import tdmOcaDBondImg from '../images/ProductImg/TdmOca/OcaDBond.jpg';
// import tdmTocaDBondImg from '../images/ProductImg/TdmTOca/TOcaDBond.jpg';
// import tdmOcrDbondImg from '../images/ProductImg/TdmOcr/OcrDBond.jpg';

// export const TpCtrlBdImg = [
//   {
//     id: 1,
//     image: require('../images/ProductImg/TouchController/TpCtrl-1.png'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-1.png',
//   },
//   {
//     id: 2,
//     image: require('../images/ProductImg/TouchController/TpCtrl-2.png'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-2.png',
//   },
//   {
//     id: 3,
//     image: require('../images/ProductImg/TouchController/TpCtrl-3.png'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-3.png',
//   },
//   {
//     id: 4,
//     image: require('../images/ProductImg/TouchController/TpCtrl-4.png'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-4.png',
//   },
//   {
//     id: 5,
//     image: require('../images/ProductImg/TouchController/TpCtrl-Exc80W60.png'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-Exc80W60.png',
//   },
//   {
//     id: 6,
//     image: require('../images/ProductImg/TouchController/TpCtrl-Exc81W60.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-Exc81W60.jpg',
//   },
//   {
//     id: 7,
//     image: require('../images/ProductImg/TouchController/TpCtrl-ILI2312C3P3.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-ILI2312C3P3.jpg',
//   },
//   {
//     id: 8,
//     image: require('../images/ProductImg/TouchController/TpCtrl-ILI2510C2P1.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-ILI2510C2P1.jpg',
//   },
//   {
//     id: 9,
//     image: require('../images/ProductImg/TouchController/TpCtrl-ILI2510C3P3.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-ILI2510C3P3.jpg',
//   },
//   {
//     id: 10,
//     image: require('../images/ProductImg/TouchController/TpCtrl-ILI2511C3P1.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-ILI2511C3P1.jpg',
//   },
//   {
//     id: 11,
//     image: require('../images/ProductImg/TouchController/TpCtrl-WDT8761A.jpg'),
//     alt: 'images/ProductImg/TouchController/TpCtrl-WDT8761A.jpg',
//     link: '',
//   },
//   // {
//   //   id: 12,
//   //   image: require('../images/ProductImg/ServDesign-12.jpg'),
//   //   alt: 'images/ProductImg/ServDesign-12.jpg',
//   //   link: '',
//   //   // link: 'https://xxxxxx.com/design/xxxxxx',
//   // },
// ]

export const TpCtrlBdTxt = [
  {
    id: 1,
    image: require('../images/ProductImg/TouchController/TpCtrl-Exc81W60.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-Exc81W60.jpg',
    name: 'EETI EXC81W60',
    title: 'EXC81W60 Controller',
    describe: 'NoChannel Tx:42/Rx:64, USB/IIC/Uart Interface',
    detail: 'EXC81W60: IC: EETI EXC81W60, No. Channel Tx:42/Rx:64, USB/IIC Interface',
  },
  {
    id: 2,
    image: require('../images/ProductImg/TouchController/TpCtrl-ILI2312C3P3.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-ILI2312C3P3.jpg',
    name: 'ILI2312C3P3',
    title: 'ILI2312 Controller',
    describe: 'NoChannel Tx:44/Rx:78, USB/IIC/Uart Interface',
    detail: 'ILI2312C3P3: ',
  },
  {
    id: 3,
    image: require('../images/ProductImg/TouchController/TpCtrl-ILI2510C2P1.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-ILI2510C2P1.jpg',
    name: 'ILI2510C2P1',
    title: 'ILI2510 Controller',
    describe: 'NoChannel Tx:xx/Rx:xx, USB/IIC/Uart Interface: ',
    detail: 'ILI2510: ',
  },
  {
    id: 4,
    image: require('../images/ProductImg/TouchController/TpCtrl-ILI2510C3P3.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-ILI2510C3P3.jpg',
    name: 'ILI2510C3P3',
    title: 'ILI2510 Controller',
    describe: 'NoChannel Tx:44/Rx:78, USB/IIC/Uart Interface',
    detail: 'ILI2510: text Lorem ipsum dolor adipising elit. Facilis, totam maiore',
  },
  {
    id: 5,
    image: require('../images/ProductImg/TouchController/TpCtrl-ILI2511C3P1.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-ILI2511C3P1.jpg',
    // fbLink: 'https://www.facebook.com',
    name: 'ILI2511C3P1',
    title: 'ILI2511C3P1 Controller',
    describe: 'NoChannel Tx:44/Rx:78, USB/IIC/Uart Interface',
    detail: 'ILI2510: text Lorem ipsum dolor st amet, consectetur adipising maiore',
  },
  {
    id: 6,
    image: require('../images/ProductImg/TouchController/TpCtrl-WDT8761A.jpg'),
    alt: 'images/ProductImg/TouchController/TpCtrl-WDT8761A.jpg',
    name: 'ILI2510 name',
    title: 'ILI2510 Controller',
    describe: 'NoChannel Tx:xx/Rx:xx, xxxx/IIC/xxxx Interface',
    detail: 'ILI2510: text Lorem ipsumamet, consecte adipising elit. Facilis, totam maiore',
  },
  {
    id: 7,
    image: require('../images/ProductImg/TouchFpca/TpFpca-1.jpg'),
    alt: 'images/ProductImg/TouchFpca/TpFpca-1.jpg',
    name: 'ILI2510 name',
    title: 'ILI2510 FPCa',
    describe: 'xxxx/IIC/xxxx Interface',
    detail: 'ILI2510: text Lorem ipsum dolor st amet, ing elit. Facilis, totam maiore',
  },
  {
    id: 8,
    image: require('../images/ProductImg/TouchFpca/TpFpca-2.jpg'),
    alt: 'images/ProductImg/TouchFpca/TpFpca-2.jpg',
    name: 'ILI2510 name',
    title: 'ILI2510 FPCa',
    describe: 'xxxx/IIC/xxxx Interface',
    detail: 'ILI2510: text Lorem dolor amet, consectetur adipis. Facilis, totam maiore',
  },
  {
    id: 9,
    image: require('../images/ProductImg/TouchFpca/TpFpca-3.jpg'),
    alt: 'images/ProductImg/TouchFpca/TpFpca-3.jpg',
    name: 'ILI2510 name',
    title: 'ILI2510 FPCa',
    describe: 'xxxx/IIC/xxxx Interface',
    detail: 'ILI2510: text Lorem adipising elit. Facilis, totam maiore',
  },
  {
    id: 10,
    image: require('../images/ProductImg/TouchFpca/TpFpca-4.jpg'),
    alt: 'images/ProductImg/TouchFpca/TpFpca-4.jpg',
    name: 'ILI2510 name',
    title: 'ILI2510 FPCa',
    describe: 'xxxx/IIC/xxxx Interface',
    detail: 'ILI2510: text Lorem doloramet, consectetur adipisingFacilis, totam maiore',
    // twitterLink: 'https://www.facebook.com',
  }
]